import Sidebar from './sidebar.service'

const SidebarTruckWheelService = {
  async fetchPossibleValues(params) {
    return Sidebar.fetchPossibleValues('/catalog/api/truck/wheel/filter-preparation', params);
  },
  async updateProductList(params) {
    return Sidebar.updateProductList('/catalog/api/truck/wheel/update-list', params);
  },
};

export default SidebarTruckWheelService;